import React from 'react';
import AgyleDialog from '../../../../../components/modal/agyleDialog';
import {useTranslation} from 'react-i18next';
import {Box, Paper} from '@mui/material';
import Grid from '@mui/material/Grid';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
    box: {
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        minHeight: 52,
        fontSize: 14,
        height: '100%',
    },
    score: {
        fontSize: 24,
        color: '#313131',
        fontWeight: 'bold',
        margin: 'auto',
    },
    description: {
        whiteSpace: 'pre-wrap',
        textAlign: 'left',
    },
}));

export const VIP_SCORE_DATA = [
    {
        id: 0,
        color: '#01AF69',
        text: `IV Site appears healthy. No pain.`,
        action: `No signs of phlebitis:
OBSERVE CANNULA`,
    },
    {
        id: 1,
        color: '#FEB03A',
        text: `One of the following:
• Slight pain near IV site
• Slight redness near IV site`,
        action: `Possible first signs of phlebitis:
OBSERVE CANNULA`,
    },
    {
        id: 2,
        color: '#DC4A5D',
        text: `Two of the following:
• Pain at IV site
• Erythema
• Swelling`,
        action: `Early stage of phlebitis:
RESITE CANNULA`,
    },
    {
        id: 3,
        color: '#DC4A5D',
        text: `All of the following signs are evident:
• Pain along path of cannula
• Erythema
• Induration`,
        action: `Medium stage of phlebitis:
RESITE CANNULA, CONSIDER TREATMENT`,
    },
    {
        id: 4,
        color: '#DC4A5D',
        text: `All of the following signs are evident and extensive:
• Pain along path of cannula
• Erythema
• Induration
• Palpable venous cord
• Pus`,
        action: `Advanced stage of phlebitis or the start of thrombophlebitis:
RESITE CANNULA, INITIATE TREATMENT, COMPLETE LERN FORM`,
    },
    {
        id: 5,
        color: '#DC4A5D',
        text: `All of the following signs are evident and extensive:
• All of the aboce plus
• Pyrexia
• Tissue damage`,
        action: `Advanced stage of thrombophlebitis:
RESITE CANNULA, INITIATE TREATMENT, COMPLETE LERN FORM`,
    },
];


const VisualInfusionPhlebitisModal = ({open, onClose}) => {
    const {t} = useTranslation();
    const classes = useStyles();

    const renderBox = (id) => {
        const item = VIP_SCORE_DATA.find(i => i.id === id);

        return (
            <>
                <Grid item xs={1}>
                    <Paper
                        style={{backgroundColor: item?.color}}
                        className={clsx(classes.box, classes.score)}
                    >
                        {id}
                    </Paper>
                </Grid>

                <Grid item xs={4}>
                    <Paper className={clsx(classes.box, classes.description)}>
                        {item?.text || '-'}
                    </Paper>
                </Grid>

                <Grid item xs={4}>
                    <Paper className={clsx(classes.box, classes.description)}>
                        {item?.action || '-'}
                    </Paper>
                </Grid>
            </>
        );
    };

    return (
        <AgyleDialog
            title={t('Visual Infusion Phlebitis (VIP) Score')}
            onClose={onClose}
            open={open}
            disableSave
            fullWidth
            width="lg"
        >
            <Box sx={{flexGrow: 1}}>
                <Grid container spacing={1} columns={9}>
                    <Grid item xs={1}>
                        <Paper className={classes.box}>
                            {t('Score')}
                        </Paper>
                    </Grid>

                    <Grid item xs={4}>
                        <Paper className={classes.box}>
                            {t('Signs')}
                        </Paper>
                    </Grid>

                    <Grid item xs={4}>
                        <Paper className={classes.box}>
                            {t('Action Guidelines')}
                        </Paper>
                    </Grid>

                    {renderBox(0)}
                    {renderBox(1)}
                    {renderBox(2)}
                    {renderBox(3)}
                    {renderBox(4)}
                    {renderBox(5)}
                </Grid>
            </Box>
        </AgyleDialog>
    );
};

export default VisualInfusionPhlebitisModal;
